import { useNavigate, useParams } from "react-router";
import t from "@/lang/lang";
import { ProcessInformationCard } from "@/routes/processes/[processId]/_components/process-information-card";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import { DeleteProcessDialog } from "@/services/backend/processes/components/delete-process-dialog";
import { H2 } from "@/shared/components/typography";

export function OverviewRoute() {
  const { processId } = useParams();
  const { data: process } = useProcessesProcessShowQuery({ id: processId! });
  const navigate = useNavigate();

  if (!process) {
    return null;
  }

  return (
    <>
      <div className="flex justify-between">
        <H2 className="border-none pb-4">{t("Übersicht")}</H2>
        <DeleteProcessDialog
          processId={process.id}
          onSuccess={() => navigate("/processes")}
        />
      </div>
      <ProcessInformationCard process={process} withServiceObjects={false} />
    </>
  );
}
